import React from 'react';
import { Route } from 'react-router-dom';
import { ContactsPage } from './ContactsPage';

export const routes = [<Route key="1" path="/contacts" component={ContactsPage} />];

export const navigation = [{ name: 'contacts', link: '/contacts' }];
